/**
 * @description: 重构size选择框组件
 * @author: zhouyh
 * @time: 2023/8/10 16:45
 */
import React from "react";
import styles from "./sizeContent.module.scss";
import filterStyles from "../../filterModal.module.scss";
import FindMyFit from "@/src/components/menuComponent/findMyFit";
import SizeGuiderButton from "@/src/components/SizeGuider/SizeGuiderButton"; // Import CSS module styles
import SizeAutoItem from "@/src/components/FilterModal/components/SizeAutoItem";
import FilterCheckBox from "@/src/components/FilterCheckBox";
import { useFilterConditionContext } from "@/src/provider";
import { CustomSizeItem } from "@/store/modules/filterConditions";
import { useTranslation } from "@/src/i18n/client";

const SizeContent: React.FC = () => {
    const [sizeId, sizeData, sizeSelect, sizeSliderSelect] =
        useFilterConditionContext((state) => [
            state.sizeId,
            state.sizeData,
            state.sizeSelect,
            state.sizeSliderSelect,
        ]);
    const { t } = useTranslation("specialSub");
    const selectOnChange = (id: number) => {
        sizeSelect(id);
    };

    const sliderOnChange = (obj: CustomSizeItem) => {
        if (sizeId !== 3) {
            sizeSelect(3);
        }
        sizeSliderSelect(obj);
    };

    return (
        <div
            className={filterStyles["filter-content-item"]}
            style={{ paddingTop: 0 }}
        >
            <div className={styles["filter-find-my-fit"]}>
                <FindMyFit
                    position="filter"
                    className={styles["h5-size-filter"]}
                />
            </div>
            <div className={styles.box}>
                {sizeData.map((val, key) => (
                    <div key={val.title}>
                        <p
                            className={
                                filterStyles["filter-content-Radio-title"]
                            }
                        >{`${t(val.title)}`}</p>
                        {val.data.map((_data, _key) => (
                            <div
                                className={filterStyles["filter-content-Radio"]}
                                key={_data.id}
                            >
                                <FilterCheckBox
                                    title={`${t(_data.title)}`}
                                    id={_data.id}
                                    onChange={selectOnChange}
                                    checked={
                                        _data.active || sizeId === _data.id
                                    }
                                />
                            </div>
                        ))}
                        {val.customData.map((_data, _key) => (
                            <SizeAutoItem
                                key={_data.id}
                                id={_data.id}
                                title={`${t(_data.title)}`}
                                img={_data.img}
                                leftVal={_data.leftVal}
                                rightVal={_data.rightVal}
                                leftTotal={_data.leftTotal}
                                rightTotal={_data.rightTotal}
                                onChange={sliderOnChange}
                            />
                        ))}
                    </div>
                ))}
                <div className={styles["size-guide-btn"]}>
                    <SizeGuiderButton>
                        {t("specialSub:SizeGuide")}
                    </SizeGuiderButton>
                </div>
            </div>
        </div>
    );
};

export default SizeContent;
